import { LOT_LOAD } from '../actions/types/LotTypes';

const INITIAL_STATE = {
  lot: {},
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case LOT_LOAD:
      if (action.result)
        return { lot: action.result.lot };
      return state;
    default: return state;
  }

};



// WEBPACK FOOTER //
// ./src/redux/reducers/LotReducer.js